import { useDashboardReskinExperiment } from '../../../../hooks/useDashboardReskinExperiment';

import { RecommendationsControl } from './control';
import { RecommendationsVariant2 } from './variant2';

export type Props = {
	viewContext: 'share' | 'home';
};

export function selectRecommendationsVariant(isReskinEnabled: boolean) {
	if (isReskinEnabled) return RecommendationsVariant2;

	return RecommendationsControl;
}

export function Recommendations({ viewContext }: Props) {
	const {
		data: { isEnabled: isReskinEnabled },
	} = useDashboardReskinExperiment();

	const Variant = selectRecommendationsVariant(isReskinEnabled);

	// eslint-disable-next-line react-hooks/static-components
	return <Variant viewContext={viewContext} />;
}
